import { isRejectedWithValue } from '@reduxjs/toolkit';
import Cookie from 'services/Cookie';
import auth from 'store/app/auth/action';
import { getActiveAuthHeaders, getActiveAuthToken } from 'utils/getActiveAuthHeaders';
import { isReactNativeWebView } from 'utils/webAuthn';
import { hasWebViewSession } from 'utils/webViewSession';

// Endpoints that should NOT trigger logout on 401
const EXCLUDED_ENDPOINTS = ['requestOTP', 'verifyOTP', 'authorizeSession', 'checkSessionStatus'];

export const unauthenticatedMiddleware =
  ({ dispatch, getState }) =>
  next =>
  action => {
    if (isRejectedWithValue(action) && action.payload?.status === 401) {
      // A 401 for a bearer that is no longer the active one (an impersonation token revoked
      // while the request was in flight) says nothing about the current session.
      const requestAuth = action.meta?.baseQueryMeta?.request?.headers?.get?.('authorization');
      const activeAuth = getActiveAuthHeaders(getState()).authorization;
      if (requestAuth && activeAuth && requestAuth !== activeAuth) {
        return next(action);
      }
      if (getState().auth?.impersonation) {
        dispatch(auth.exitImpersonation({ reason: 'expired' }));
        return next(action);
      }
      const hasSession = Boolean(
        getActiveAuthToken(getState().auth)?.hash || Cookie.get('impersonate')?.hash,
      );
      // Cookie sessions from store builds (no injected WebView session) are still the app bearer.
      if (!hasSession || hasWebViewSession() || isReactNativeWebView()) {
        return next(action);
      }
      // Check if this is an excluded endpoint (like OTP verification)
      const endpointName = action.meta?.arg?.endpointName;
      if (!EXCLUDED_ENDPOINTS.includes(endpointName)) {
        dispatch(auth.logout());
      }
    }
    return next(action);
  };
